import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { InsideSystemSection } from '../components/InsideSystemSection';
import { LibrarySection } from '../components/LibrarySection';
import { BonusesSection } from '../components/BonusesSection';
import { TransformationSection } from '../components/TransformationSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
export function Landing() {
  return <div className="w-full bg-ivory" data-id="element-246" data-mp="m8n1m1aqmm4x">
      <Hero data-id="element-247" data-mp="m5heuspkzwcd" />
      <main data-id="element-248" data-mp="2a0l6a3b6s8u">
        <ProblemSection data-id="element-249" data-mp="29sa8nqqxx0a" />
        <SolutionSection data-id="element-250" data-mp="2b3a4ch2mkm4" />
        <InsideSystemSection data-id="element-251" data-mp="2bbpcb0o220h" />
        <LibrarySection data-id="element-252" data-mp="3tgbflndtcur7" />
        <BonusesSection data-id="element-253" data-mp="3tg20wvy7ya0t" />
        <TransformationSection data-id="element-254" data-mp="3tfjxnfd52vje" />
        <TestimonialsSection data-id="element-255" data-mp="3tio7as9dijhg" />
        <OfferSection data-id="element-256" data-mp="3pe81eqzrfc28" />
        <GuaranteeSection data-id="element-257" data-mp="3pfrmqw09wdav" />
        <FaqSection data-id="element-258" data-mp="3pezyy7cx3jv5" />
        <FinalCtaSection data-id="element-259" data-mp="3kfn16rkicsds" />
      </main>
      <Footer data-id="element-260" data-mp="3kgophxqjbbdg" />
      <PurchaseNotifications data-id="element-261" data-mp="3kgyebhzufchk" />
    </div>;
}